import { SchedulerTaskAPI } from "../api"

export class SchedulerTask {
  constructor(props) {
    for (const [key, value] of Object.entries(props)) {
      this[key] = value;
    }
  }
  static async createSchedulerTask(formData){
    const { data } = await SchedulerTaskAPI.createSchedulerTask(formData);
    return new SchedulerTask(data.result)
  }

  static async updateSchedulerTask(formData){
    const { data } = await SchedulerTaskAPI.updateSchedulerTask(formData);
    return new SchedulerTask(data.result)
  }

  static async getSchedulerTasksByContract(formData){
    const { data } = await SchedulerTaskAPI.getSchedulerTasksByContract(formData);
    return data.result.map(task => new SchedulerTask(task))
  }

  static async getSchedulerTask(id){
    const { data } = await SchedulerTaskAPI.getSchedulerTask(id);
    return new SchedulerTask(data.result)
  }

  static async removeSchedulerTask(id){
    const { data } = await SchedulerTaskAPI.removeSchedulerTask(id);
    return new SchedulerTask(data.result)
  }

  static async activeSchedulerTask(formData){
    const { data } = await SchedulerTaskAPI.activeSchedulerTask(formData);
    return new SchedulerTask(data.result)
  }
}